import { connect } from 'react-redux';
import Deliveries from './Deliveries';
import { getFormValues, isDirty, reset } from 'redux-form';
import { bindActionCreators, Dispatch } from 'redux';
import { actions as uiActions } from 'ducks/ui';
import { IApplicationState } from 'ducks/reducers';

const FORM_NAME = 'PurchaseOrderDeliveriesForm';
const mapStateToProps = (state: IApplicationState) => ({
    formValues: getFormValues(FORM_NAME)(state),
    dirty: isDirty(FORM_NAME)(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
        resetForm: () => reset(FORM_NAME),
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Deliveries);
